<template>
  <div>

    <Form
      :form="form"
      purpose="add"
      route="lab-reports"
    />

  </div>
</template>

<script>


import Form from '@/component/lab-reports/Form.vue'
import Card from '@/view/content/Card.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        date: '',
        patient_id: '',
        doctor_id: '',
        lab_template_id: '',
        report: '',
        lab_category_id: '',
        attachment: [],
        display_attachment: [],
        removed_attachment: []
      },
    }
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pemeriksaan Lab" },
      { title: "Tambah Laporan" },
    ])
  },

}
</script>
